import React, { useEffect, useState } from 'react'
import { IoMdArrowBack } from 'react-icons/io';
import { Link, useNavigate, useParams } from 'react-router-dom';
import dummy from '../../assets/images/dummy.png'
import { Button } from 'react-bootstrap';
import { addProductSubCategory, getProductsListing, getProductsSubcategoryListing } from '../../api/context/products';
import toast from 'react-hot-toast';
import Loader from '../../components/loader/loader';

const CreateSubCategoriesProducts = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [update, setUpdate] = useState(false);

    const previousUrl = () => {
        navigate(-1)
    }

    const fetchProductsData = async () => {

        getProductsSubcategoryListing(id)((response) => {
            if (response?.statusCode === 200) {
                setData(response?.data?.productsWithImages);
                setTotalRows(response?.data?.totalCount);
                setLoading(false)

            } else {
                setData([])
                setLoading(false)
            }
        })
    }

    const addProductCategory = (pdid, id) => {
        addProductSubCategory({ productId: pdid, subcategoryId: id })((response) => {
            if (response?.statusCode === 200) {
                setLoading(false)
                toast.success("Product Added Successfully")
                navigate(-1)
                setUpdate(!update);
            } else {
                toast.error(response?.data?.message);
                setLoading(false)
            }
        })
    }

    useEffect(() => {
        setLoading(true);
        fetchProductsData();

    }, [update]);

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center">
                            <Link onClick={() => previousUrl()} className='back_btn_wrap'>
                                <IoMdArrowBack className='icon' />
                            </Link>
                            <h4 className="mb-sm-0">Sub Categories Products</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className='card_bg'>
                            {loading ? (
                                <div style={{ height: '60vh' }}>
                                    <Loader />
                                </div>
                            ) : (
                                data?.map((product, index) => (
                                    <div className='card_wrapper_products' key={index}>
                                        <div className='dflex_prduct_wrapper'>
                                            <div className='card_img_wrapper'>
                                                <img src={product?.images?.[0] ? product?.images?.[0] : dummy} alt={product?.productName} className='img-fluid card_img' />

                                            </div>
                                            <div className='card_content_wrapper'>
                                                <h5>{product?.productName}</h5>
                                                <p dangerouslySetInnerHTML={{ __html: product?.description }} />
                                            </div>
                                        </div>
                                        <div className='card_btn_wrapper'>
                                            <Button className='request_btn' onClick={() => addProductCategory(product?.id, id)}>Add Product</Button>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>



                </div>
            </div>
        </>
    )
}

export default CreateSubCategoriesProducts